export default __webpack_public_path__ + "static/preschool10-d14cd4dd5e10aa7c9ad30a07eede6ea7.jpg";